import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import SimpleTable from 'components/table/SimpleTable';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MobileTable from 'components/table/MobileTable';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    color: theme.palette.icon,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  toggleButtonGroup: {
    maxHeight: '35px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      width: '100%',
    },
  },
  toggleButton: {
    minWidth: 100,
    [theme.breakpoints.down('sm')]: {
      minWidth: '33%',
    },
  },
  toggleLabel: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  cardHeader: {
    padding: '0',
    zIndex: 200,
    display: 'flex',
    marginBottom: theme.spacing(3),
  },
  picker: {
    marginTop: theme.spacing(1),
  },
  toggles: {
    display: 'flex',
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  visibleSmall: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

const OrganizationsListTable = ({
  organizations,
  selectedOrganizationId,
  isFetchingOrganizations,
  handleOrganizationSelect,
}) => {
  const classes = useStyles();
  const mobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { t } = useTranslation();

  const selectSingleOrganization = (event, organization) => {
    handleOrganizationSelect(organization);
  };

  const tableHeader = [
    {
      alias: 'name',
      sortable: true,
      mobilePreview: true,
      mobileInfo: true,
      format: 'string',
      dataAlias: 'name',
      dataRender: (s) => (
        <Typography className={classes.nameCell} align={'center'}>
          {s.name}
        </Typography>
      ),
    },
    {
      alias: 'audience',
      sortable: true,
      mobileInfo: true,
      format: 'string',
      dataAlias: 'audience',
      dataRender: (s) => (
        <Typography className={classes.nameCell} align={'center'}>
          {s.audience}
        </Typography>
      ),
    },
    {
      alias: 'description',
      sortable: true,
      mobileInfo: true,
      format: 'string',
      dataAlias: 'description',
      dataRender: (s) => (
        <Typography className={classes.nameCell} align={'center'}>
          {s.description}
        </Typography>
      ),
    },
  ];

  return mobileView ? (
    <MobileTable
      title={t('orgs')}
      tableHeader={tableHeader}
      data={organizations}
      selectRow={selectSingleOrganization}
    />
  ) : (
    <SimpleTable
      title={t('orgs')}
      tableHeader={tableHeader}
      data={organizations}
      isLoading={isFetchingOrganizations}
      selected={selectedOrganizationId}
      selectRow={selectSingleOrganization}
    />
  );
};

OrganizationsListTable.propTypes = {
  organizations: PropTypes.array,
  selectedOrganizationId: PropTypes.any,
  handleOrganizationSelect: PropTypes.func.isRequired,
  isFetchingOrganizations: PropTypes.bool.isRequired,
};

OrganizationsListTable.defaultProps = {
  organizations: [],
  selectedOrganizationId: '',
};

export default OrganizationsListTable;
